import type { ChipTone } from "@/components/badge/chip";
import type { Engagement } from "@/types/domain";

// Engagement priority scale within its current App pool or version. Stored
// value: bigger = more urgent (3 = the old ❗️❗️❗️); shown as P0 (highest) … P3,
// where P3 is also the default for 0 / unset.
export const PRIORITIES: { value: number; label: string; tone: ChipTone }[] = [
  { value: 3, label: "P0", tone: "red" },
  { value: 2, label: "P1", tone: "orange" },
  { value: 1, label: "P2", tone: "yellow" },
  { value: 0, label: "P3", tone: "neutral" },
];

export const priorityOf = (engagement: Engagement) =>
  PRIORITIES.find((p) => p.value === (engagement.priority ?? 0)) ??
  PRIORITIES[PRIORITIES.length - 1];
